export const GET_IMAGE_SUCCESS = "GET_IMAGE_SUCCESS";
export const GET_CONTENT_SUCCESS = "GET_CONTENT_SUCCESS";
export const GET_LINKEDIN_LOGO_SUCCESS = "GET_LINKEDIN_LOGO_SUCCESS";
export const GET_MEDIUM_LOGO_SUCCESS = "GET_MEDIUM_LOGO_SUCCESS";
export const GET_GITHUB_LOGO_SUCCESS = "GET_GITHUB_LOGO_SUCCESS";
export const GET_GITLAB_LOGO_SUCCESS = "GET_GITLAB_LOGO_SUCCESS";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_PROJECTS_SUCCESS="GET_PROJECTS_SUCCESS";
export const GET_WEB_DESIGN_PROJECTS_SUCCESS="GET_WEB_DESIGN_PROJECTS_SUCCESS";
export const SET_LANGUAGE="SET_LANGUAGE";
export const SPANISH_LANGUAGE= "Spanish";
export const ENGLISH_LANGUAGE="English";
export const GET_PROJECTS_BY_DATETIME_REQUEST="GET_PROJECTS_BY_DATETIME_REQUEST";
export const GET_WEB_DESIGN_PROJECTS_BY_DATETIME_REQUEST="GET_WEB_DESIGN_PROJECTS_BY_DATETIME_REQUEST";
export const GET_BLOGS_BY_DATETIME_REQUEST="GET_BLOGS_BY_DATETIME_REQUEST"